import {
  getSelectedRoutes,
  RouteState,
  TravelTimes,
} from "src/helpers/mapConstants";
import { formatTime } from "src/lib/stringFormats";
import TimeLabel from "../ui/TimeLabel";
import RouteLineExample from "./RouteLineExample";
import { useContext } from "react";
import { LanguageContext } from "../languageContext";

export default function RoutePopup({
  routeState,
  travelTimes,
}: {
  routeState: RouteState;
  travelTimes?: TravelTimes;
}) {
  const { translate } = useContext(LanguageContext);

  if (!travelTimes) return null;
  return (
    <div>
      <h5 className="mb-4 text-[18px] font-bold">{translate("travelTimes")}</h5>
      {getSelectedRoutes(routeState).map((routeName) => {
        return (
          <div
            key={routeName}
            className="flex justify-between items-center mb-4 space-x-2"
          >
            <div className="flex items-center space-x-2">
              <RouteLineExample scenario={routeName} />
              <h4 className="text-[14px]">
                {translate(`altName-${routeName}`)}
              </h4>
            </div>
            <TimeLabel {...formatTime(travelTimes?.[routeName] ?? 0)} />
          </div>
        );
      })}
    </div>
  );
}
